import React, { useEffect, useState } from 'react';
import { Box, Stack, Tab, Tabs } from '@mui/material';
import map from 'lodash/map';

import { ContentProps, Props, TabPanelProps } from './props';

const TabContentSwitcherView: React.FC<Props> = (props) => {
  //========= PROPS DESTRUCTURING
  const {
    contents,
    defaultTab = 0,
    parentTabsProps,
    parentContainerProps,
    onCurrentSelectedTab,
    tabPanelContainerProps,
    ...rest
  } = props;

  // =========== STATE
  const [value, setValue] = useState(defaultTab);

  useEffect(() => {
    if (defaultTab) {
      setValue(defaultTab);
    }
  }, [defaultTab]);

  const identifier = (id: ContentProps['id']) => {
    return {
      id: `tab-${id}`,
      'aria-controls': `tabpanel-${id}`,
      value: id,
    };
  };

  // =========== EVENTS
  const onTabChange = (e: React.SyntheticEvent, newValue: number) => {
    onCurrentSelectedTab?.(newValue);
    setValue(newValue);
  };

  // =========== VIEW
  const renderTabPanel = (props: TabPanelProps) => {
    const { children, value, id, tabPanelProps } = props;
    return (
      <Stack
        key={id}
        role="tabpanel"
        hidden={value !== id}
        id={`tab-${id}`}
        aria-labelledby={`tabpanel-${id}`}
        {...tabPanelProps}
      >
        {value === id && children}
      </Stack>
    );
  };

  return (
    <Stack overflow="hidden" {...rest}>
      <Box overflow={'hidden '} {...parentContainerProps}>
        <Tabs
          value={value}
          variant="scrollable"
          allowScrollButtonsMobile
          aria-label="tabs"
          onChange={onTabChange}
          {...parentTabsProps}
        >
          {map(contents, (tab) => {
            const { name, id, tabProps } = tab || {};
            return (
              <Tab key={id} {...tabProps} label={name} {...identifier(id)} />
            );
          })}
        </Tabs>
      </Box>
      <Box {...tabPanelContainerProps}>
        {map(contents, (content) => {
          const { id, children, tabPanelProps } = content || {};
          return renderTabPanel({ id, children, value, tabPanelProps });
        })}
      </Box>
    </Stack>
  );
};

export const TabContentSwitcher = TabContentSwitcherView;
export default TabContentSwitcherView;
